require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./post-new-year-new-blog-new-something.json") })
        }
      }, "path---post-new-year-new-blog-new-something");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---post-new-year-new-blog-new-something!./.cache/json/post-new-year-new-blog-new-something.json
// module id = 344
// module chunks = 231608221292675